module.exports = __webpack_public_path__ + "static/media/new-all3d-white.bef6122e.svg";